import React from "react";
import "./AboutUsSection.css";

// Images
import img1 from "../Assets/images/amplehouse.jpeg";
import img2 from "../Assets/images/tobeused7.jpg";
import img3 from "../Assets/images/tobeused16.jpg";

// ✅ Import Video (LOCAL FILE)
import aboutVideo from "../Assets/videos/training2.mp4";

const AboutUsSection = () => {
  return (
    <section className="about-section">
      <div className="container">
        
        <h2 className="about-title">About Ample House</h2>

        <div className="about-grid">
          
          {/* LEFT COLUMN - MEDIA */}
          <div className="about-media">
            
            {/* Video */}
            <div className="video-wrapper">
              <video
                src={aboutVideo}
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            {/* Image Layout */}
            <div className="image-grid">
              <div className="large-img">
                <img src={img1} alt="Ample House" />
              </div>
              <div className="small-imgs">
                <img src={img2} alt="Ample House" />
                <img src={img3} alt="Ample House" />
              </div>
            </div>

          </div>

          {/* RIGHT COLUMN - TEXT */}
          <div className="about-text">
            <p>
              <strong>Ample House</strong> is a dynamic creative and learning ecosystem built to inspire ideas, shape stories, and develop impactful leadership. At its core, Ample House brings together creativity, education, and community to empower individuals and organizations to create meaningful change.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;